/* eslint-disable */
/* tslint:disable */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  NgZone,
  TemplateRef,
} from '@angular/core';
import { ProxyCmp, proxyOutputs } from '../angular-component-lib/utils';
import { Components } from '@bkkr/core';
export declare interface BkkrDrawer extends Components.BkkrDrawer {
  /**
   * Emitted after the drawer has presented.
   **/
  bkkrDrawerDidPresent: EventEmitter<CustomEvent>;
  /**
   * Emitted before the drawer has presented.
   */
  bkkrDrawerWillPresent: EventEmitter<CustomEvent>;
  /**
   * Emitted before the drawer has dismissed.
   */
  bkkrDrawerWillDismiss: EventEmitter<CustomEvent>;
  /**
   * Emitted after the drawer has dismissed.
   */
  bkkrDrawerDidDismiss: EventEmitter<CustomEvent>;
  /**
   * Emitted after the drawer has presented. Shorthand for bkkrDrawerWillDismiss.
   */
  didPresent: EventEmitter<CustomEvent>;
  /**
   * Emitted before the drawer has presented. Shorthand for bkkrDrawerWillPresent.
   */
  willPresent: EventEmitter<CustomEvent>;
  /**
   * Emitted before the drawer has dismissed. Shorthand for bkkrDrawerWillDismiss.
   */
  willDismiss: EventEmitter<CustomEvent>;
  /**
   * Emitted after the drawer has dismissed. Shorthand for bkkrDrawerDidDismiss.
   */
  didDismiss: EventEmitter<CustomEvent>;
}

@ProxyCmp({
  inputs: [
    'animated',
    'backdropDismiss',
    'canDismiss',
    'closeButton',
    'closeIcon',
    'cssClass',
    'duration',
    'enterAnimation',
    'event',
    'handle',
    'isOpen',
    'keepContentsMounted',
    'keyboardClose',
    'leaveAnimation',
    'presentingElement',
    'showBackdrop',
    'swipeToClose',
    'trigger',
  ],
  methods: ['present', 'dismiss', 'onDidDismiss', 'onWillDismiss'],
})
@Component({
  selector: 'bkkr-drawer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div class="bkkr-page" *ngIf="isCmpOpen || keepContentsMounted">
    <ng-container [ngTemplateOutlet]="template"></ng-container>
  </div>`,
  inputs: [
    'animated',
    'backdropDismiss',
    'canDismiss',
    'closeButton',
    'closeIcon',
    'cssClass',
    'duration',
    'enterAnimation',
    'event',
    'handle',
    'isOpen',
    'keepContentsMounted',
    'keyboardClose',
    'leaveAnimation',
    'presentingElement',
    'showBackdrop',
    'swipeToClose',
    'trigger',
  ],
})
export class BkkrDrawer {
  @ContentChild(TemplateRef, { static: false }) template: TemplateRef<any>;

  isCmpOpen: boolean = false;

  protected el: HTMLElement;

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    this.el = r.nativeElement;

    this.el.addEventListener('willPresent', () => {
      this.isCmpOpen = true;
      c.detectChanges();
    });
    this.el.addEventListener('didDismiss', () => {
      this.isCmpOpen = false;
      c.detectChanges();
    });

    proxyOutputs(this, this.el, [
      'bkkrDrawerDidPresent',
      'bkkrDrawerWillPresent',
      'bkkrDrawerWillDismiss',
      'bkkrDrawerDidDismiss',
      'didPresent',
      'willPresent',
      'willDismiss',
      'didDismiss',
    ]);
  }
}
